import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { Space } from "@masterteam/mt-design-react";
import { ReactComponent as ArrowIcon } from "../../../assets/images/arrow-down-curve.svg";

import "./style.scss";

const KPIChangeRequestsMenu = ({ KPIDetails }) => {
  const wrapperRef = useRef();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const { direction } = useSelector((store) => store.language);

  const handleClickOutside = (event) => {
    if (wrapperRef?.current && !wrapperRef?.current?.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`menu-container ${direction}`} ref={wrapperRef}>
      {KPIDetails?.AllowChangeRequestCreation ? (
        <Space
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          className="menu-title"
          align="center"
          size="medium"
        >
          <FormattedMessage id="add-change-request" />
          <ArrowIcon fill="white" width={14} height={14} />
        </Space>
      ) : null}

      {isOpen && (
        <Space className="menu-box" direction="vertical">
          {KPIDetails?.AllowDetailsChangeRequest ? (
            <div
              className="menu-item"
              onClick={() => {
                history.push(
                  `/splus/change-kpi-details?kpi=${KPIDetails?.ID}&type=1`
                );
              }}
            >
              <FormattedMessage id="change-kpi-details" />
            </div>
          ) : null}

          {KPIDetails?.AllowMeasurementChangeRequest ? (
            <div
              className="menu-item"
              onClick={() => {
                history.push(
                  `/splus/change-kpi-measurements?kpi=${KPIDetails?.ID}&type=2`
                );
              }}
            >
              <FormattedMessage id="change-kpi-measures" />
            </div>
          ) : null}

          {KPIDetails?.AllowActualValuesChangeRequest ? (
            <div
              className="menu-item"
              onClick={() => {
                history.push(
                  `/splus/change-kpi-actual-values?kpi=${KPIDetails?.ID}&type=3`
                );
              }}
            >
              <FormattedMessage id="change-kpi-actual-values" />
            </div>
          ) : null}

          {KPIDetails?.AllowParametersChangeRequest ? (
            <div
              className="menu-item"
              onClick={() => {
                history.push(
                  `/splus/change-kpi-parameters?kpi=${KPIDetails?.ID}&type=4`
                );
              }}
            >
              <FormattedMessage id="change-kpi-parameters" />
            </div>
          ) : null}
        </Space>
      )}
    </div>
  );
};

export default KPIChangeRequestsMenu;
